import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { HEADER_NAV_MENU_DEALER, HEADER_NAV_MENU_MANUFACTURER } from 'app/constants';
import { NavItem } from 'models/nav.model';
import { OfferBase } from 'models/offer.model';
import { BaseComponent } from 'shared/base/base.component';
import { OfferService } from 'shared/services/offer.service';
import { StoreService } from 'shared/services/store.service';
import { SettingsService } from 'shared/services/settings.service';
import { Branch } from 'graphql/models/generated';

@Component({
  selector: 'app-header-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.scss']
})
export class HeaderMainNavComponent extends BaseComponent implements OnInit {
  menu: NavItem[] = [];

  lastVisitedOffer: { hideNavItem: boolean; urlPath: string; data: OfferBase } = {
    hideNavItem: true,
    urlPath: '',
    data: {
      documentId: '',
      revision: 0,
      title: ''
    }
  };

  currentSubmenu: number | null = null;

  constructor(
    private router: Router,
    private offerService: OfferService,
    private storeService: StoreService,
    private settingsService: SettingsService
  ) {
    super();
  }

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    this.initStoreData();
  }

  private initStoreData(): void {
    combineLatest([
      this.storeService.getLastVisitedOffer(),
      this.storeService.getCurrentOffer(),
      this.storeService.isCurrentAccountDealer()
    ])
      .pipe(takeUntil(this.destroyed$))
      .subscribe(([lastVisitedOffer, currentOfferStore, isDealer]: [OfferBase, OfferBase, boolean]) => {
        this.menu = isDealer ? HEADER_NAV_MENU_DEALER : HEADER_NAV_MENU_MANUFACTURER;
        this.setLastVisitedOfferData(lastVisitedOffer, currentOfferStore);
      });
  }

  private setLastVisitedOfferData(lastVisitedOffer: OfferBase | null, currentOfferStore: OfferBase): void {
    if (!lastVisitedOffer || !lastVisitedOffer.documentId) return;

    this.lastVisitedOffer.data = lastVisitedOffer;
    this.lastVisitedOffer.urlPath = `/offer/${lastVisitedOffer.documentId}/${lastVisitedOffer.revision}`;

    const currentOffer = currentOfferStore || ({} as OfferBase);

    this.lastVisitedOffer.hideNavItem =
      currentOffer.documentId === lastVisitedOffer.documentId && currentOffer.revision === lastVisitedOffer.revision;
  }

  goToCurrentOffer() {
    if(this.lastVisitedOffer.data.branchId) {
      this.settingsService.getBranch(this.lastVisitedOffer.data.branchId).subscribe((branch: Branch) => {
        this.storeService.setCurrentAccountBranch(branch);
        this.router.navigateByUrl(this.lastVisitedOffer.urlPath);
      });
    }
  }

  onNavItemClick(title: string): void {
    switch (title) {
      case 'NAV.NEW_OFFER':
        this.offerService.createOffer().subscribe({
          next: (documentId: string) => {
            this.router.navigateByUrl(`/offer/${documentId}/0`);
          },
          error: (error) => {
            console.error('createOffer.error', error);
          }
        });

      // eslint-disable-next-line no-fallthrough
      default:
        break;
    }
  }

  toggleSubMenu(index: number | null) {
    this.currentSubmenu = index;
  }
}
